
<app-view-entity [contextIdDto]="contextIdDto"
                 [eventBus]="eventBus"
                 [entityInstanceId]="viewEntityInstanceDto.entityInstanceId.id" *ngIf="contextIdDto && viewEntityInstanceDto"></app-view-entity>

<button mat-fab color="accent" [disabled]="trialExpiredService.isTrialExpired()" class="mat-fab-bottom-right" (click)="create()" style="z-index: 9;">
    <mat-icon class="mat-24">add</mat-icon>
</button>
